/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { useFormContext, UseFormRegisterReturn, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { actions, getQuote } from '../../../features/quote/QuoteSlice';
import { Field } from '../../../types';
import useModal from '../../hooks/useModal';
import Modal from '../modal/Modal';
import Tooltip from '../Tooltip';

export interface RadioProps {
    field: Field;
    error?: string;
    inputRef: UseFormRegisterReturn;
}

function RadioInput(props: RadioProps) {
  const tooltip = useRef(null);
  const { field, error, inputRef } = props;
  const { data } = useSelector(getQuote);
  const [modals, setModals] = useState<any>({});
  const { setValue, control } = useFormContext();
  const dispatch = useDispatch();
  const {
    modalOpen, setModalOpen, toggle, setOpenModal,
  } = useModal({
    count: field.modals ? field.modals.length : 0,
    initialMode: false,
  });

  const keys = Object.keys(field.options);

  const radioValue = useWatch({ control, name: inputRef.name });
  useEffect(() => {
    setValue(inputRef.name, data[field.formId] || radioValue);
    dispatch(actions.updateQuote({
      quote: [
        {
          ...field,
          value: data[field.formId] || radioValue,
        },
      ],
    }));
  }, [radioValue]);

  const handleLabelClick = (e: any) => {
    if (e.target.dataset.toggle) {
      const id = e.target.dataset.target.replace('#', '');
      if (Object.prototype.hasOwnProperty.call(modals, id)) {
        setOpenModal(modals[id], true);
      }
    }
    return e.preventDefault();
  };

  useEffect(() => {
    if (field.modals) {
      const modalObject : any = {};
      field.modals.forEach((modal: any, modalIndex: number) => {
        modalObject[modal.id] = modalIndex;
      });
      setModals(modalObject);
    }
  }, [field.modals]);

  return (
    <div className={`mb-4 form-card p-4 ${error ? 'error' : ''}`}>
      <label htmlFor={field.id} className="form-label my-2">
        <span
          onClick={handleLabelClick}
          dangerouslySetInnerHTML={{ __html: field.label }}
        />
        {/* <button type="button" onClick={handleLabelClick}>Click</button> */}
        {field.required
                    && <span className="ms-2 d-inline-block asterix">*</span>}
      </label>
      <div className="radio">
        {keys.map((key: string, index: number) => {
          const option = field.options[key];
          const domId = `${field.formId}-${index}`;
          return (
            <div key={key} className="form-check form-check-inline d-inline-flex align-content-center">
              <div className="input-container">
                <input
                  data-name={`${field.formId}`}
                  id={domId}
                  checked={data[field.formId] === option.value || field.value === option.value}
                  {...inputRef}
                  className="form-check-input align-self-center"
                  type="radio"
                  value={option.value}
                />
              </div>
              <label
                dangerouslySetInnerHTML={{ __html: option.text }}
                className="form-check-label align-self-center ms-3"
                htmlFor={domId}
              />
            </div>
          );
        })}
      </div>
      <div className="form-card-footer d-flex  justify-content-between">
        {
                    error
                    && <small className="error ">{error}</small>
                }
        {field.tooltip && <Tooltip tooltipText={field.tooltip} />}
      </div>
      {field.modals && field.modals
        .map((modal: any, modalIndex: number) => (
          <Modal
            key={modalIndex}
            onClose={() => setOpenModal(modalIndex, false)}
            showModal={modalOpen[modalIndex]}
            modalText={modal.body}
            modalTitle={modal.title}
          />
        ))}

    </div>
  );
}

RadioInput.defaultProps = {
  error: false,
};

export default RadioInput;
